import React from 'react';
import '../styles/FilterChip.css';

function FilterChip(props) {
    const label = props.label;
    const selected = props.selected;
    const index = props.index;
    const disabled = props.disabled;
    const textColour = selected === true ? "colour-white" : "colour-primary";
    const leftIcon = props.leftIcon;
    const rightIcon = props.rightIcon;
    const func = props.func;
    // Optional count suffix. `count == null` (undefined or null) hides the
    // badge entirely; explicit `count: 0` renders "(0)" so empty buckets are
    // still discoverable. Used by the Leads toolbar state chips.
    const count = props.count;
    const showCount = count !== undefined && count !== null;

    return (
        <div
            className={"filter-chip-outer-container " + (selected === true ? "filter-chip-selected " : "filter-chip-unselected ") + (disabled === true ? "disabled" : "cursor-pointer")}
            onClick={() => disabled === false ? func(index) : null}
        >
            <div className="filter-chip-inner-container">
                {
                    leftIcon !== null &&
                    leftIcon
                }
                <span className={"body-regular block-text text-align-center " + (textColour)}>
                    {label}
                </span>
                {showCount && (
                    <span className={"filter-chip-count xs-label-bold " + (textColour)}>
                        {count}
                    </span>
                )}
                {
                    rightIcon !== null &&
                    rightIcon
                }
            </div>
        </div>
    )
};

export default FilterChip;